import React from 'react'
import "./ds.css"

const ds = () => {
  return (
    <div id='DS' className='container__delicate-solutions'>
    <div className='container__delicate-solutions-header'>
      <div className='glass-box'>
       <h1>Delicate Solutions</h1>
       <p>Delicate Solutions provides comprehensive software services that empower businesses to establish a strong online presence and engage with their customers effectively. From web and mobile app development to simple game design and professional logo creation, Delicate Solutions has got you covered.</p>
      </div>
    </div>
    </div>
  )
}

export default ds
